import { PaymentTerm } from '@cemex-core/cmx-api';
import {
  LOAD_PAYMENT_TERMS_FROM_PRODUCT_COMPLETE,
  LOAD_PAYMENT_TERMS_FROM_SALESAREAS_COMPLETE,
  PaymentTermsActions,
  RESET,
} from '../../actions/payment-terms.actions';

export interface PaymentTermState {
  defaultPaymentTerm: PaymentTerm;
  availablePaymentTerms: {
    [productId: string]: any[];
  };
}

export const initialState: PaymentTermState = {
  defaultPaymentTerm: null,
  availablePaymentTerms: {},
};

export function paymentTermFormReducer(state = initialState, action: PaymentTermsActions): PaymentTermState {
  switch (action.type) {
    case LOAD_PAYMENT_TERMS_FROM_PRODUCT_COMPLETE: {
      return {
        ...state,
        availablePaymentTerms: {
          ...state.availablePaymentTerms,
          [action.payload.productId]: action.payload.paymentTerms,
        },
      };
    }
    case LOAD_PAYMENT_TERMS_FROM_SALESAREAS_COMPLETE: {
      return {
        ...state,
        defaultPaymentTerm: action.payload,
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
